var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullDao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7072 27.7844C66.1804 27.7844 67.2128 24.6069 65.2039 23.1422L34.6375 0.907758C34.201 0.587943 33.6739 0.415527 33.1328 0.415527C32.5916 0.415527 32.0646 0.587943 31.6281 0.907758L1.06166 23.1422C-0.947284 24.5989 0.0852028 27.7844 2.56637 27.7844H7.52071V57.7185H1.75799C1.40583 57.7185 1.11769 58.0067 1.11769 58.3588V64.9219C1.11769 65.2741 1.40583 65.5622 1.75799 65.5622H64.5076C64.8597 65.5622 65.1479 65.2741 65.1479 64.9219V58.3588C65.1479 58.0067 64.8597 57.7185 64.5076 57.7185H58.7449V27.7844H63.7072ZM22.6478 57.7185H13.2834V27.7844H22.6478V57.7185ZM37.775 57.7185H28.4106V27.7844H37.775V57.7185ZM52.9821 57.7185H43.5377V27.7844H52.9821V57.7185Z",
    fill: "#81FEB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullDao);
export default __webpack_public_path__ + "static/media/full-dao.0598ac625feb5edd26931310b2ab3450.svg";
export { ForwardRef as ReactComponent };